import Select from "react-select";
import useLang from "Shared/hooks/useLanguage";
import { reactSelectSMStyle2, styles } from "Utils/Common";
import type { SelectOption } from "./pathologyReportData";

type Props = {
  value: SelectOption | null;
  onChange: (value: SelectOption | null) => void;
  options: SelectOption[];
  placeholder?: string;
  className?: string;
};

const PathologyReportSelect = ({
  value,
  onChange,
  options,
  placeholder,
  className = "h-30px",
}: Props) => {
  const { t } = useLang();

  return (
    <Select
      className={className}
      classNamePrefix="react-select"
      menuPortalTarget={document.body}
      placeholder={t(placeholder ?? "--- Select ---")}
      value={value}
      onChange={(v) => onChange(v as SelectOption | null)}
      options={options.map((o) => ({
        ...o,
        label: t(o.label),
        isDisabled: o.isDisabled,
      }))}
      styles={reactSelectSMStyle2("30px")}
      theme={styles}
      isClearable
      isSearchable
    />
  );
};

export default PathologyReportSelect;
